import type { PriceListUerRowDataFilterInput } from 'gql/graphql';

import { debounce } from 'debounce';
import { useCallback, useMemo, useState } from 'react';

import { getWhere } from '../../../WorkOrderChange/helpers';

export const useUerWorkOrderPriceListFilters = () => {
    const [filters, setFilters] = useState<Record<string, any>>({});
    const [searchString, setSearchString] = useState('');

    const onSearch = useCallback(({ value }) => {
        setFilters((currentFilters) => ({ ...currentFilters, searchString: value }));
    }, []);

    const debouncedSearch = useMemo(() => debounce(onSearch, 500), [onSearch]);

    const onSearchStringChange = useCallback(
        ({ value }) => {
            setSearchString(value);
            debouncedSearch({ value });
        },
        [debouncedSearch],
    );

    const onSearchStringClear = useCallback(() => {
        if (searchString) {
            setSearchString('');

            setFilters((prevFilters) => ({
                ...prevFilters,
                searchString: undefined,
            }));
        }
    }, [searchString]);

    const changeFilterHandler = useCallback(({ fieldName, checkedValues }) => {
        setFilters((prevValues) => ({
            ...prevValues,
            [fieldName]: checkedValues?.length ? checkedValues : undefined,
        }));
    }, []);

    const where = useMemo(() => getWhere<PriceListUerRowDataFilterInput>(filters), [filters]);

    return {
        where,
        onSearchStringClear,
        onSearchStringChange,
        searchString,
        onSearch,
        changeFilterHandler,
        filters,
    };
};
